<script lang="ts">
  export let value: number = 0;
  export let max: number = 5;
</script>

<div class="stars">
  {#each Array(Math.min(value, max)) as _, index (index)}
    <i class="material-icons icon-base"> star </i>
  {/each}
  {#each Array(max - Math.min(value, max)) as _, index (index)}
    <i class="material-icons icon-base"> star_border </i>
  {/each}
</div>

<style>
  .stars {
    display: flex;
    flex-direction: row;
    color: #ffcc33;
  }
</style>
